<template>
    <TextareaWithLabel :label="showlabel == true ? Strings['Forms.Comments'] : ''"
                       v-model="comments"
                       rows="5" />
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            showlabel: {
                type: Boolean,
                default: true,
                required: false
            }
        },
        data() {
            return {
                
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            comments: {
                get() { return this.$store.state.comments; },
                set(val) { this.$store.commit('setComments', val); }
            }
        },
        methods: {
        },
        components: {
        }
    };
</script>